import React from 'react'

import { getAspectRatioPadding } from './utils/getAspectRatioPadding'

import { TIconProps } from './iconProps'

const IconCloseInCircle: React.FC<TIconProps> = (props) => {
  return (
    <div style={props.style} className={`select-none ${props.className || 'w-24'}`} onClick={props.onClick}>
      <div className="relative h-0" style={getAspectRatioPadding(props.aspectRatio)}>
        <svg xmlns="http://www.w3.org/2000/svg" className="w-full h-full left-0 top-0 absolute" viewBox="0 0 32 32">
          <g>
            <circle cx="16" cy="16" r="15" fill="#FFF" stroke="#DCE6EB" strokeWidth="2" />
            <path
              fill="currentColor"
              d="M11.757 10.343L16 14.585l4.244-4.242c.39-.39 1.023-.39 1.414 0 .39.39.39 1.024 0 1.414L17.414 16l4.243 4.244c.39.39.39 1.023 0 1.414-.39.39-1.024.39-1.414 0l-4.244-4.243-4.242 4.243c-.39.39-1.023.39-1.414 0-.39-.39-.39-1.024 0-1.414l4.242-4.244-4.242-4.242c-.39-.39-.39-1.023 0-1.414.39-.39 1.024-.39 1.414 0z"
            />
          </g>
        </svg>
      </div>
    </div>
  )
}
export default IconCloseInCircle
